export const DEFAULT_ANALYTICS_FILTER_SETTINGS = {
  shouldIgnoreZfUsers: false,
  shouldIgnoreAnonymousUsers: false,
  filteredEmailDomains: [],
  shorterThanDuration: null,
  longerThanDuration: null
};